'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ContentAdvisoryTypePicker = require('./components/ContentAdvisoryTypePicker');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ContentAdvisoryTypePicker).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-ugc-editors/lib/components/content-advisory-type-picker/index.js
// module id = 551
// module chunks = 1